'use client';

import type { Product } from '@packages/gql/generated/shopping/graphql';
import { Link } from '@packages/modules/src/Link/Link';
import { buildUrl } from '@packages/shared/src/utils/buildUrl/buildUrl';
import { useSearchParams } from 'next/navigation';

export type BackToProductLinkProps = {
  akl: Product['akl'];
  className?: string;
} & React.PropsWithChildren;

export const BackToProductLink = ({ akl, children, className }: BackToProductLinkProps) => {
  const searchParams = useSearchParams();
  const backToProductLink = buildUrl({ pathname: `/p/${akl}`, searchParams });

  return (
    <Link href={backToProductLink} className={className}>
      {children}
    </Link>
  );
};
